import { render, staticRenderFns } from "./Vestibular.vue?vue&type=template&id=387bcb01&scoped=true&lang=pug&"
import script from "./Vestibular.vue?vue&type=script&lang=js&"
export * from "./Vestibular.vue?vue&type=script&lang=js&"
import style0 from "./Vestibular.styl?vue&type=style&index=0&id=387bcb01&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387bcb01",
  null
  
)

export default component.exports